var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll",on:{"scroll":_vm.handleScroll}},_vm._l((_vm.msgs),function(msg,index){return _c('chat-message',{key:index,attrs:{"msg":msg,"maskedLength":_vm.maskedLength,"custNo":_vm.custNo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }